import Vue from 'vue'
const vm = new Vue()

const url_prefix = "/file";

export function getUploadUrl() {
  return vm.$http.FileadornUrl(getUrl(`/fdfs/upload`)) + `?token=${vm.$cookie.get('token')}`
}

function getUrl(url) {
  return url_prefix + url;
}






// WEBPACK FOOTER //
// ./src/api/file_api.js